/**
 * Mirrors packages/contracts/src/error-envelope.ts. Not imported directly —
 * apps/client is a browser bundle and packages/contracts is a Node-composite
 * TS project; duplicating the closed union here is cheaper than wiring a
 * cross-runtime build target for one shared type. Keep in sync by hand; a
 * new code added there is a compile error here once the type is used.
 */
export const ERROR_CODES = [
  'NOT_FOUND',
  'VALIDATION_FAILED',
  'INVITE_NOT_ACCEPTABLE',
  'BAD_REQUEST',
  'FORBIDDEN',
  'TENANT_READ_ONLY',
  'TENANT_UNAVAILABLE',
  'RATE_LIMITED',
  'IDEMPOTENCY_KEY_REUSED',
  'IDEMPOTENCY_KEY_IN_FLIGHT',
  'PARTY_ROLE_INVALID',
  'MODULE_DISABLED',
  'PR_REQUIRED',
  'COA_NOT_EMPTY',
  'COA_NOT_CONFIGURED',
  'MEMBERSHIP_DISABLED',
  'INTERNAL',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export interface FieldProblem {
  readonly path: string;
  readonly message: string;
  readonly code?: string | undefined;
}

export interface ErrorEnvelope {
  readonly error: {
    readonly code: ErrorCode;
    readonly message: string;
    readonly requestId: string;
    readonly details?: readonly FieldProblem[];
    readonly retryAfterSeconds?: number;
  };
}

export function isErrorEnvelope(value: unknown): value is ErrorEnvelope {
  return (
    typeof value === 'object' &&
    value !== null &&
    'error' in value &&
    typeof (value as { error?: unknown }).error === 'object'
  );
}
